/* eslint-disable react/jsx-no-undef */
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { Autocomplete, AutocompleteInputChangeReason, Box, Breakpoint, Checkbox, DialogActions, DialogContent, DialogTitle, Grid, Icon, IconButton, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField } from "@mui/material";
import DialogContext from 'components/confirm-dialog-context';
import CustomDialog from 'components/custom/CustomDialog';
import MiniImagem from 'components/ProdutoImagem/MiniImagem';
import { CustomButton } from 'components/roundedbutton/CustomButton';
import useCatchApiError from 'hooks/useCatchApiError';
import HeaderOuBannerDependendoDaInterpretacaoH1, { headerOuBannerDependendoDaInterpretacaoH1defaultFontSize } from 'layout/header-ou-banner-dependendo-da-interpretacao-h1/HeaderOuBannerDependendoDaInterpretacaoH1';
import { IAbstractModel } from 'model/abstract.model';
import { GenericTO } from "model/generic.model";
import { IProduto } from 'pages/registra-venda/registra-venda.model';
import RegistraVendaService from 'pages/registra-venda/registra-venda.service';
import React, { SyntheticEvent, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { addUuidsProdutoEstoque } from 'redux/features/imagemReducer';
import { useAppDispatch, useAppSelector } from "redux/hooks";
import EstabelecimentoService from 'service/Estabelecimento.service';
import { theme } from 'theme';
import { currencyOf, decimalOf, isEmpty, resolveWrapper } from 'utils/util';
import Sound from '../../assets/barcode_error.mp3';
import BoxesStacked from './BoxesStacked';
import { Filters } from 'components/infinitescrollvirtuoso/InfiniteScrollVirtuoso';
import CabecalhoColunaFiltravel from 'components/tabelafiltravel/CabecalhoColunaFiltravel';
import { COLUNAS_FILTRAVEIS, LARGURA_ESPACADA, LARGURA_ESTABELECIMENTO, LARGURA_IMAGEM, LARGURA_PRODUTO } from './consulta-estoque-colunas';
import ConsultaEstoqueService, { TConsultaEstoque } from "./ConsultaEstoque.service";
import CustomProdutoImagensDialog from 'components/ProdutoImagem/CustomProdutoImagensDialog';

interface Props {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onClose?: () => void;
    maxWidth?: Breakpoint | false;
    fullWidth?: boolean;
}

const BEEPSOUND = new Audio(Sound);

const ConsultaEstoque = (props: Props) => {
    const dialog = useContext(DialogContext);

    const configuracaoBalcao = useAppSelector(e => e.configuracoes.configuracaoPedidoBalcao);
    const estabelecimentoSelecionado = useAppSelector(e => e.estabelecimentoSelecionado);
    const registraVendaService = RegistraVendaService();
    const estabelecimentoService = EstabelecimentoService();
    const consultaEstoqueService = ConsultaEstoqueService();
    const { throwErrorMessage } = useCatchApiError()

    const procurandoPorProdutoRef = useRef(false);
    const codigoBarrasRef = useRef<HTMLInputElement>(null);
    const skuRef = useRef<HTMLInputElement>(null);
    const skusRef = useRef<boolean>(false);
    const produtoBuscaRef = useRef(0);
    const consultaRef = useRef(0);
    const produtoDebounceRef = useRef<ReturnType<typeof setTimeout>>();
    const {
        imagens
    } = useAppSelector(e => e.imagens)
    const dispatch = useAppDispatch();

    const initialState = {
        rows: [] as Array<TConsultaEstoque>,
        tabelaPreco: configuracaoBalcao.tabelaPreco as IAbstractModel | null,
        tabelasPreco: [] as Array<GenericTO>,
        skus: [] as Array<IProduto>,
        skuFiltro: "" as string,
        skuSelecionada: null as IProduto | null,
        produtos: [] as GenericTO[],
        produtoSelecionado: null as GenericTO | null,
        estabelecimentos: [] as Array<GenericTO>,
        estabelecimentosSelecionados: [] as Array<GenericTO>,
        procurandoPorProduto: procurandoPorProdutoRef.current as boolean,
        uuidProduto: null as null | string
    };
    const [stateLocal, setStateLocal] = useState(initialState);
    const [filters, setFilters] = useState<Filters>({});

    const rowsFiltradas = useMemo(
        () => isEmpty(Object.keys(filters))
            ? stateLocal.rows
            : stateLocal.rows.filter(row =>
                Object.entries(filters).every(([key, filtro]) => filtro.apply(resolveWrapper(row, key), row))),
        [stateLocal.rows, filters],
    );

    const quantidadeTotal = useMemo(
        () => rowsFiltradas.reduce((soma, row) => soma + row.sku.estoque.saldoEstoque, 0),
        [rowsFiltradas],
    );

    useEffect(() => {
        dispatch(addUuidsProdutoEstoque([...stateLocal.rows]))
        //eslint-disable-next-line
    }, [stateLocal.rows])


    const handleClose = () => {
        props.setOpen(false);
    };

    const handleKeyDown = (e: KeyboardEvent) => {
        switch (e.key) {
            case 'e':
                if (e.altKey) {
                    e.preventDefault();
                    props.setOpen(false);
                }
                break;
        }
    };

    const toggleAndResetProcurandoPorProduto = (conditionToToggle: boolean) => {
        if (conditionToToggle) {
            procurandoPorProdutoRef.current = !procurandoPorProdutoRef.current;
            setStateLocal(prevState => ({
                ...prevState,
                procurandoPorProduto: procurandoPorProdutoRef.current
            }));
        };
        resetFocus();
    };

    const resetFocus = () => {
        setTimeout(() => {
            if (procurandoPorProdutoRef.current) {
                skuRef.current?.focus();
            } else {
                codigoBarrasRef.current?.focus();
            }
        },);
    };

    const handleF4 = (e: KeyboardEvent) => {
        switch (e.key) {
            case 'F4':
                e.preventDefault();
                const idEmFoco = document.activeElement?.id;
                const conditionToToggle = idEmFoco === 'acSku-inputConsultaEstoque' || idEmFoco === 'inputConsultaEstoque-input';
                toggleAndResetProcurandoPorProduto(conditionToToggle);
                break;
        }
    };

    useEffect(() => {
        window.addEventListener('keydown', handleF4);
        return () => {
            window.removeEventListener('keydown', handleF4);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateLocal.procurandoPorProduto]);

    const getEstabelecimentoAc = () => {
        estabelecimentoService.getEstabelecimentosAtivosQuePossuemConfiguracaoPedidoBalcao()
            .then(({ data }) => {
                setStateLocal(prevState => ({
                    ...prevState,
                    estabelecimentos: data,
                    estabelecimentosSelecionados: data.filter(e => e.uuid === estabelecimentoSelecionado.uuid)
                }));
            }).catch(error => {
                throwErrorMessage(error)
            });
    };

    const onSelectEstabelecimento = (e: SyntheticEvent<Element, Event>, value: any) => {
        if (!value) return;
        setStateLocal(prevState => ({
            ...prevState,
            estabelecimentosSelecionados: value
        }));
    };

    const getSkusAc = (toSearch: string = '') => {
        if (!configuracaoBalcao.tabelaPreco) return;
        registraVendaService.getSkusAc(toSearch, stateLocal.tabelaPreco?.uuid ?? configuracaoBalcao.tabelaPreco!.uuid)
            .then(({ data }) => {
                setStateLocal(prevState => ({
                    ...prevState,
                    skus: data
                }));
            }).catch(error => {
                throwErrorMessage(error)
            });
    };

    const uuidTabelaPreco = () => stateLocal.tabelaPreco?.uuid ?? configuracaoBalcao.tabelaPreco?.uuid;

    const getProdutosAc = (toSearch: string = '') => {
        const uuid = uuidTabelaPreco();
        if (!uuid) return;

        const busca = ++produtoBuscaRef.current;
        consultaEstoqueService.getProdutosAc(toSearch, uuid)
            .then(({ data }) => {
                if (busca !== produtoBuscaRef.current) return;
                setStateLocal(prevState => ({
                    ...prevState,
                    produtos: data
                }));
            }).catch(error => {
                throwErrorMessage(error)
            });
    };

    const onInputChangeProdutoAc = (e: SyntheticEvent<Element, Event>, value: string, reason: AutocompleteInputChangeReason) => {
        if (reason === 'reset') return;
        clearTimeout(produtoDebounceRef.current);
        produtoDebounceRef.current = setTimeout(() => getProdutosAc(value), 300);
    };

    const onSelectProduto = (e: SyntheticEvent<Element, Event> | null, value: GenericTO | null) => {
        if (!value) {
            resetConsultaEstoque();
            return;
        }
        if (codigoBarrasRef.current) codigoBarrasRef.current.value = '';
        setFilters({});
        setStateLocal(prevState => ({
            ...prevState,
            produtoSelecionado: value,
            skuSelecionada: null
        }));
        const consulta = ++consultaRef.current;
        consultaEstoqueService.getConsultaEstoquePorProduto(
            value.uuid,
            uuidTabelaPreco()!,
            stateLocal.estabelecimentosSelecionados.flatMap(e => e.uuid)
        ).then(({ data }) => {
            if (consulta !== consultaRef.current) return;
            setStateLocal(prevState => ({ ...prevState, rows: data }));
        }).catch((err) => {
            if (consulta !== consultaRef.current) return;
            throwErrorMessage(err)
            resetConsultaEstoque();
        });
    };

    const onInputCodigoBarras = (e: React.KeyboardEvent<HTMLDivElement>) => {
        const inputValue = codigoBarrasRef.current?.value;
        if (e.key === 'Enter' && inputValue) {
            registraVendaService.getProdutoByCodigo(inputValue, uuidTabelaPreco()!)
                .then(({ data }) => {
                    const skuSelecionada: IProduto = data;
                    setFilters({});
                    setStateLocal(prevState => ({
                        ...prevState,
                        skuSelecionada: skuSelecionada,
                        produtoSelecionado: null
                    }));
                    const consulta = ++consultaRef.current;
                    consultaEstoqueService.getConsultaEstoque(
                        data.uuid,
                        uuidTabelaPreco()!,
                        stateLocal.estabelecimentosSelecionados.flatMap(e => e.uuid)
                    ).then(({ data }) => {
                        if (consulta !== consultaRef.current) return;
                        setStateLocal(prevState => ({ ...prevState, rows: data }));
                    }).catch((err) => {
                        if (consulta !== consultaRef.current) return;
                        throwErrorMessage(err)
                        resetConsultaEstoque();
                    });
                }).catch(error => {
                    BEEPSOUND.play();
                    dialog.confirm({
                        error: true,
                        title: 'Atenção',
                        message: `CÓDIGO DE BARRAS ${inputValue} NÃO ENCONTRADO NA TABELA DE PREÇO ${configuracaoBalcao.tabelaPreco?.descritivo ?? ""}`,
                        onConfirm: () => { }
                    });
                });
            codigoBarrasRef.current.value = '';
            resetFocus();
        }
    };

    const skusOptions = () => {
        const skusList = Array.isArray(stateLocal.skus) ? stateLocal.skus : [];
        const filtro = stateLocal.skuFiltro;

        if (!filtro) { return skusList; }

        const toReturn = skusList.filter(e => {
            let skuFormat = `${e.codigoSku}/${e.nome}/${e.cor}/${e.tamanho}`;
            return skuFormat.toLowerCase().includes(filtro.toLowerCase());
        });

        if (isEmpty(toReturn) && filtro) {
            skusRef.current = true;
            return skusList;
        }

        return toReturn;
    };

    useEffect(() => {
        if (skusRef.current || isEmpty(stateLocal.skuFiltro)) {
            skusRef.current = false;
            getSkusAc(stateLocal.skuFiltro);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skusRef.current, stateLocal.skuFiltro]);

    const onBlurSkus = () => {
        if (!stateLocal.skuFiltro) {
            getSkusAc();
        }
    };

    const onInputChangeSkuAc = useCallback((e: SyntheticEvent<Element, Event>, value: string) => {
        setStateLocal(prevState => ({ ...prevState, skuFiltro: value }));
    }, []);

    const onSelectSku = (e: SyntheticEvent<Element, Event> | null, value: IProduto | null) => {
        if (!value) return;
        setFilters({});
        setStateLocal(prevState => ({
            ...prevState,
            skuSelecionada: value,
            produtoSelecionado: null
        }));
        const consulta = ++consultaRef.current;
        consultaEstoqueService.getConsultaEstoque(
            value.uuid,
            uuidTabelaPreco()!,
            stateLocal.estabelecimentosSelecionados.flatMap(e => e.uuid)
        ).then(({ data }) => {
            if (consulta !== consultaRef.current) return;
            setStateLocal(prevState => ({ ...prevState, rows: data }));
        }).catch((err) => {
            if (consulta !== consultaRef.current) return;
            throwErrorMessage(err)
            resetConsultaEstoque();
        });

    };

    const getTabelasPrecosAc = useCallback((toSearch: string = ' ') => {
        consultaEstoqueService.getTabelaPreco(toSearch)
            .then(({ data }) => {
                setStateLocal(prevState => ({ ...prevState, tabelasPreco: data }));
            }).catch(() => { });
        //eslint-disable-next-line
    }, []);

    const onInputChangeTabelaPrecoAc = useCallback((e: React.ChangeEvent<{}>, value: string) => {
        getTabelasPrecosAc(value);
        //eslint-disable-next-line
    }, []);

    const onSelectTabelaPreco = useCallback((e: SyntheticEvent<Element, Event>, value: GenericTO | null) => {
        if (!value) return;
        setStateLocal(prevState => ({ ...prevState, tabelaPreco: value }));
        //eslint-disable-next-line
    }, []);

    const resetConsultaEstoque = useCallback(() => {
        setFilters({});
        setStateLocal(prevState => ({ ...prevState, rows: [], skuSelecionada: null, produtoSelecionado: null }));
        resetFocus();
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.open === true) {
            getTabelasPrecosAc();
            getEstabelecimentoAc();
            resetFocus();
            setFilters({});
            setStateLocal(prevState => ({
                ...prevState,
                tabelaPreco: configuracaoBalcao.tabelaPreco
            }));
        }
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.open]);

    useEffect(() => {
        getProdutosAc();
        getSkusAc();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateLocal.tabelaPreco]);

    useEffect(() => {
        if (stateLocal.produtoSelecionado) {
            onSelectProduto(null, stateLocal.produtoSelecionado);
            return;
        }
        onSelectSku(null, stateLocal.skuSelecionada);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stateLocal.tabelaPreco, stateLocal.estabelecimentosSelecionados]);

    const onOpenImage = useCallback((uuidProduto: string) => {
        setStateLocal(prevState => ({
            ...prevState,
            uuidProduto
        }))
    }, [])

    const onClose = useCallback(() => {
        setStateLocal(prevState => ({
            ...prevState,
            uuidProduto: initialState.uuidProduto
        }))
        //eslint-disable-next-line
    }, [])

    return (
        <>
            <CustomDialog
                fullWidth={true}
                maxWidth={'xl'}
                open={props.open}
                onClose={handleClose}
            >
                <DialogTitle style={{ textAlign: 'center' }}>
                    <HeaderOuBannerDependendoDaInterpretacaoH1
                        id='consulta-estoque'
                        customIcon={
                            <BoxesStacked id='vendaShoppingCarIcon' color={theme.palette.text.primary} fontSize={headerOuBannerDependendoDaInterpretacaoH1defaultFontSize.normal} />
                        }
                        label='Consulta estoque'
                    />
                </DialogTitle>

                <DialogContent>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={3} lg={3} padding={1}>
                            <Autocomplete
                                value={stateLocal.tabelaPreco}
                                disablePortal
                                id="acTabelaPreco"
                                options={stateLocal.tabelasPreco}
                                getOptionLabel={(option) => option.descritivo}
                                onInputChange={onInputChangeTabelaPrecoAc}
                                filterOptions={(x) => x}
                                noOptionsText={'Nenhum resultado encontrado'}
                                onChange={onSelectTabelaPreco}
                                isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
                                renderInput={
                                    (params) => <TextField {...params}
                                        label="Tabela de preço"
                                        variant="standard"
                                        InputProps={{
                                            ...params.InputProps,
                                        }}
                                    />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3} padding={1}>
                            <Autocomplete
                                value={stateLocal.produtoSelecionado}
                                disablePortal
                                id="ac-produto-consulta-estoque"
                                options={stateLocal.produtos}
                                getOptionLabel={(option) => option.descritivo}
                                onInputChange={onInputChangeProdutoAc}
                                filterOptions={(x) => x}
                                noOptionsText={'Nenhum resultado encontrado'}
                                onChange={onSelectProduto}
                                isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
                                renderInput={
                                    (params) => <TextField {...params}
                                        label="Produto"
                                        variant="standard"
                                        InputProps={{
                                            ...params.InputProps,
                                        }}
                                    />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3} padding={1}>
                            {!stateLocal.procurandoPorProduto &&
                                <TextField
                                    fullWidth={true}
                                    variant="standard"
                                    placeholder={stateLocal.tabelaPreco?.descritivo ?? ""}
                                    label='Código de barras | Código do sku'
                                    id="acSku-inputConsultaEstoque"
                                    InputProps={{
                                        endAdornment: (
                                            <React.Fragment>
                                                <h4 className="h4-formatado">(F4)</h4>
                                                <IconButton
                                                    onClick={() => {
                                                        toggleAndResetProcurandoPorProduto(true);
                                                    }}
                                                    sx={{ height: 0, padding: 0, paddingLeft: '5px' }}
                                                >
                                                    <Icon className="fa-solid fa-barcode" />
                                                </IconButton>
                                            </React.Fragment>
                                        )
                                    }}
                                    onKeyUp={onInputCodigoBarras}
                                    inputRef={codigoBarrasRef}
                                />}
                            {stateLocal.procurandoPorProduto &&
                                <Autocomplete
                                    onBlur={onBlurSkus}
                                    disablePortal
                                    id="inputConsultaEstoque-input"
                                    options={skusOptions()}
                                    getOptionLabel={o => `${o.codigoSku}/${o.nome}/${o.cor}/${o.tamanho}`}
                                    isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
                                    onInputChange={onInputChangeSkuAc}
                                    onChange={onSelectSku}
                                    value={null}
                                    blurOnSelect={true}
                                    filterOptions={(x) => x}
                                    noOptionsText={'Nenhum resultado encontrado.'}
                                    renderInput={
                                        (params) => <TextField {...params}
                                            label="Nome tamanho cor do sku"
                                            variant="standard"
                                            placeholder={stateLocal.tabelaPreco?.descritivo}
                                            inputRef={skuRef}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        <h4 className="h4-formatado">(F4)</h4>
                                                        <IconButton
                                                            onClick={() => {
                                                                toggleAndResetProcurandoPorProduto(true);
                                                            }}
                                                            sx={{ height: 0, padding: 0, paddingLeft: '5px' }}
                                                        >
                                                            <LocalOfferIcon />
                                                        </IconButton>
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }}
                                        />}

                                />}
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3} padding={1}>
                            <Autocomplete
                                multiple
                                id="multiAcEstabelecimentos"
                                options={stateLocal.estabelecimentos}
                                value={stateLocal.estabelecimentosSelecionados}
                                onChange={onSelectEstabelecimento}
                                disableCloseOnSelect
                                limitTags={1}
                                noOptionsText={'Nenhum resultado encontrado.'}
                                getOptionLabel={e => e.descritivo}
                                isOptionEqualToValue={(option, value) => option.uuid === value.uuid}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                                            checked={selected}
                                        />
                                        {option.descritivo}
                                    </li>
                                )
                                }
                                renderInput={(params) => (
                                    <TextField {...params} label="Estabelecimentos" variant='standard' />
                                )} sx={{
                                    '.MuiAutocomplete-tag': {
                                        backgroundColor: theme.palette.background.default,
                                        height: '1.2rem',
                                        maxWidth: 'calc(100% - 60px)'
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                    <TableContainer sx={{ marginTop: 3, height: 'min(500px, 45vh)' }} >
                        <Table size="small" stickyHeader sx={{
                            minWidth: 650,
                            '& .MuiTableHead-root .MuiTableCell-root': { py: 2, backgroundColor: theme.palette.background.paper },
                            '& .MuiTableBody-root .MuiTableCell-root': { py: 0.25 },
                            '& .MuiTableFooter-root .MuiTableCell-root': {
                                py: 0.25,
                                position: 'sticky',
                                bottom: 0,
                                zIndex: 2,
                                backgroundColor: theme.palette.background.paper
                            }
                        }} >
                            <TableHead>
                                <TableRow>
                                    <TableCell align='center' sx={LARGURA_IMAGEM}>Imagem</TableCell>
                                    {COLUNAS_FILTRAVEIS.map(column => (
                                        <CabecalhoColunaFiltravel
                                            key={column.id}
                                            column={column}
                                            sx={column.sx}
                                            filters={filters}
                                            setFilters={setFilters}
                                        />
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {isEmpty(rowsFiltradas) &&
                                    <TableRow>
                                        <TableCell colSpan={6} sx={{ borderBottom: 'none' }}>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: 2,
                                                height: 380,
                                                color: theme.palette.text.disabled
                                            }}>
                                                <Icon className='fa-solid fa-boxes-stacked' sx={{ fontSize: 44, width: 'fit-content' }} />
                                                <Box sx={{ fontSize: 16, textAlign: 'center' }}>
                                                    {isEmpty(stateLocal.rows)
                                                        ? 'Nenhum produto sendo exibido. Informe um produto, código de barras ou código do sku para consultar o estoque.'
                                                        : 'Nenhum produto encontrado para o filtro aplicado.'}
                                                </Box>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                }
                                {rowsFiltradas.map((row, index) => (
                                    <TableRow
                                        key={'row_' + index}
                                        sx={{ height: '25px' }}
                                    >
                                        <MiniImagem
                                            descritivo={row.sku.descritivo}
                                            imagens={imagens.filter(e => e.uuidProduto === row.sku.uuidProduto)}
                                            onOpenImage={onOpenImage}
                                            uuidProduto={row.sku.uuidProduto}
                                            style={LARGURA_IMAGEM}
                                        />
                                        <TableCell component="th" scope="row" sx={LARGURA_ESTABELECIMENTO}>
                                            {row.estabelecimento}
                                        </TableCell>
                                        <TableCell align='left' sx={LARGURA_PRODUTO}>{row.sku.descritivo}</TableCell>
                                        <TableCell align="left" sx={LARGURA_ESPACADA}>{decimalOf({ value: row.sku.estoque.saldoEstoque })}</TableCell>
                                        <TableCell align="left" sx={LARGURA_ESPACADA}>{row.sku.estoque.nomeDeposito}</TableCell>
                                        <TableCell align="left" sx={LARGURA_ESPACADA}>{row.sku.preco ? currencyOf(row.sku.preco) : 'R$ -'}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            {!isEmpty(rowsFiltradas) && <TableFooter>
                                <TableRow>
                                    <TableCell align='right' colSpan={3} sx={{ fontWeight: 800, fontSize: 14 }}>
                                        Total:
                                    </TableCell>
                                    <TableCell align="left" sx={{ ...LARGURA_ESPACADA, fontWeight: 800, fontSize: 14 }}>
                                        {decimalOf({ value: quantidadeTotal })}
                                    </TableCell>
                                    <TableCell align='left' colSpan={2}></TableCell>
                                </TableRow>
                            </TableFooter>
                            }
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <CustomButton id={"close_consulta_estoque_btn"}
                        onClick={handleClose}
                        variant="contained"
                        color="error"
                        startIcon={<Icon className={'fa-solid fa-close'} sx={{ width: 'fit-content' }} />}
                    >
                        Fechar
                    </CustomButton>
                </DialogActions>
            </CustomDialog>

            {!!stateLocal.uuidProduto &&
                <CustomProdutoImagensDialog
                    imagens={imagens.find(e => e.uuidProduto === stateLocal.uuidProduto) ?? null}
                    onClose={onClose}
                    uuidProduto={stateLocal.uuidProduto}
                />
            }
        </>
    );
};

export default ConsultaEstoque;
